// Dependencies
import React, { useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Functions
import { apiUser } from '@api/common';

// Components
import Loading from '@components/common/Loading';

// State
import { userSetter, userState } from '@state/auth';

export default function WithUser(Component: any) {
  return function WrappedComponent(props: any) {
    const user = useRecoilValue(userState);
    const setUser = useSetRecoilState(userSetter);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
      (async () => {
        setLoading(true);
        const res = await apiUser.get.self();
        if (res.ok) setUser(res.data);
        setLoading(false);
      })();
    }, []);

    return !loading ? <Component {...props} /> : <Loading />;
  };
}
